import { DelaysManagerPage } from "./DelaysManagerPage";

const DelaysManager = () => {
	return <DelaysManagerPage />;
};
export default DelaysManager;
